<div class="custom-task-modal">
  <div class="alert-attention d-flex align-items-center gap-2 p-2 mb-2">
    <i class="pi pi-exclamation-triangle"></i>
    <span>Tienes <strong>{{ listArticleTasks.length }}</strong> tareas programadas.</span>
  </div>
  <div class="tasks-container d-flex flex-column gap-3">
    <div *ngFor="let task of listArticleTasks" class="task-card container-style p-3 position-relative"
      [ngClass]="{'border-left-defeated': task.statusDate === defeatedStatus, 'border-left-schedule': task.statusDate === scheduleStatus}">
      <div class="d-flex align-items-center gap-2 mb-2">
        <span class="badge-task px-2 py-1">
          <i class="pi pi-box me-1"></i> Tarea #{{task.consecutive }}
        </span>
        <span class="ms-auto badge-status" [ngClass]="{'vencida': task.statusDate === defeatedStatus}">
          <i class="pi" [ngClass]="task.statusDate === defeatedStatus ? 'pi-exclamation-triangle' : 'pi-calendar'"></i>
          {{task.statusDate === defeatedStatus ? 'Vencida' : 'Programada'}}
        </span>
      </div>
      <span class="fw-bold text-uppercase"> {{task.articleCode}} - {{task.articleName}} </span>
      <div class="row g-2 my-1 text-secondary small">
        <div class="col-12 d-flex gap-2">
          <i class="pi pi-file-edit mt-1"></i>
          <span>{{task.description}}</span>
        </div>
        <div class="col-12 d-flex gap-2">
          <span>{{task.observation}}</span>
        </div>
      </div>
      <hr class="my-3 border-light-subtle" *ngIf="task.dateArticleTask">
      <div class="d-flex align-items-center justify-content-between mt-2">
        <div class="d-flex align-items-center gap-2 text-muted small">
          <i class="pi pi-bell"></i>
          <span>Fecha de ejecución: <strong>{{task.dateArticleTask | date: 'dd/MM/yyyy'}}</strong></span>
        </div>
        <app-custom-button *ngIf="visibleButton" [title]="'Finalizar tarea'" [label]="'Finalizar tarea'"
          [icon]="'pi pi-arrow-right'" [iconPos]="'right'" [width]="'8rem'" [severity]="'success'" [variant]="undefined"
          (click)="executeTask(task)"></app-custom-button>
      </div>
    </div>
  </div>